import { createAsyncThunk } from '@reduxjs/toolkit';
import { FirebaseError } from 'firebase/app';
import { doc, onSnapshot, setDoc } from 'firebase/firestore';
import { createCollection, removeUndefinedProperties } from '../firestore-helpers';
import { AppUser, listenerUpdateUser } from "../state/users";

const usersCollection = createCollection<AppUser>('users');

/**
 * 
 * @param AppUser 
 * @returns Promise<AppUser>
 */
export const saveUser = async (user: AppUser): Promise<void> => {
    const userRef = doc(usersCollection, user.uid);
    await setDoc(userRef, removeUndefinedProperties(user), { merge: true });
    return;
}

let unsubscribeUser = ():void => { };

export const startListeningUser = createAsyncThunk<
    void,
    AppUser,
    {
        rejectValue: FirebaseError;
    }
>(
    'users/startListeningUser',
    async (user: AppUser, thunkAPI) => {
        unsubscribeUser();
        const userRef = doc(usersCollection, user.uid);
        unsubscribeUser = onSnapshot(userRef, (docSnapshot) => {
            if (docSnapshot.exists()) {
                const updatedUser = docSnapshot.data();
                thunkAPI.dispatch(listenerUpdateUser(updatedUser));
            } else {
                console.warn('User data was deleted. This should never happen.');
            }
        }, (error: FirebaseError) => {
            return thunkAPI.rejectWithValue(error);
        });
    }
);

export const stopListeningUser = createAsyncThunk<
    void,
    void,
    {}
>(
    'users/stopListeningUser',
    () => {
        unsubscribeUser();
    }
);
